import { useState } from "react"
import "../Styles/Signup.css"
import {  PasswordInput, TextInput } from '@mantine/core';
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo3.jpg"
import axios from "axios";
import { url } from "../db/url";
import { toast } from "react-toastify";
import VerifyOtp from "../components/VerifyOtp";
import Cookies from "js-cookie";

const Signin = () => {
    const [details, setDetails] = useState({
        email: "",
        password: ""
    })
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const navigate = useNavigate()
    const handleSubmit = (e) => {
        e.preventDefault()
        setLoading(true)
        axios.post(`${url}/api/v2/user/login-user`, {...details})
        .then(res => {
            console.log(res)
            setLoading(false)
            toast.success("Signin Successfull")
            Cookies.set("TOKEN", res.data.token)
            Cookies.set("NAME", res.data.user.name)
            Cookies.set("ROLE", res.data.user.role)
            Cookies.set("TYPE", res.data.user._type)
            navigate('/')
        }).catch(err => {
            setLoading(false)
            console.log(err)
            toast.error(err.response ? err.response.data.message : "Network Error")
        })
    }



    const resendMail = () => {
        if(!details["email"]){
            toast.error("Please enter your email address")
            return
        }
        toast.info("Please wait")
        axios.post(`${url}/api/v2/user/send-otp`, {email: details["email"]})
        .then(res => {
            toast.success(res.data.message)
            setShowModal(true)
        }).catch(err => {
            console.log(err)
            toast.error(err.response.data.message)
        })
    }
    const handleClose = () => {
        setShowModal(false)
    }

    return<>
        <VerifyOtp modal={showModal} onClose={handleClose} email={details['email']}/>
        <div className="signup">
            <div className="signupWrapper">
                <img src={logo} alt="" />
                <form action="">
                    <div className="formHeading">
                        <h2>Sign In</h2>
                        <p>Sign up to your farmcart account</p>
                    </div>

                    <div className="inputContainer">
                        <TextInput
                            label="Email Address:"
                            description="Enter a valid email address"
                            placeholder="abc@example.com"
                            value={details['email']}
                            onChange={(e) => setDetails({...details, email: e.target.value})}
                            type="email"
                        />
                        <PasswordInput
                            label= "Password"
                            description="Please enter a strong password"
                            value={details['password']}
                            onChange={(e) => setDetails({...details, password: e.target.value})}
                            placeholder="*******"
                        />
                        <div className="links">
                            <span onClick={resendMail}>Verify Account</span>
                            <NavLink to={"/forgot"}> Forgot Password</NavLink>
                        </div>
                    </div>
                    <button className="btn" onClick={handleSubmit} disabled={loading} >{loading ? "Loading..." : "Sign In"}</button>
                    <p  className="lastChild">Don't have an account? <NavLink to={"/signup"}>Sign Up</NavLink></p>
                </form>
            </div>
        </div>
    </>

}

export default Signin